import { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import Loader from './Loader/Loader.jsx'
import "./assets/Dashboard.css";
import "./assets/DashboardResponsive.css";
import { FaSyncAlt } from "react-icons/fa";
import { logout } from "./slice/authSlice";
import Snackbar from '@mui/material/Snackbar';
import { getSocket } from "./socket/socket.js";
import { setReadCount, setUserTyping } from './slice/uiSlice.jsx'
import CustomSnackbar from './CustomSnackbar .jsx'; // adjust path if needed
import updateUnreadCounts from './slice/uiSlice.jsx'
import React, { StrictMode } from 'react'
import ChatIcon from "./chat/Chatcomponet/ChatIcon.jsx";
import ChatAppSmall from './chat/Chatcomponet/Small/SmallMain.jsx';
import UserPresence from './chat/Chatcomponet/UserPresence.jsx';
import { OnCreateGroup, OnGetMyGroups } from '../src/slice/chatSlice.jsx';
import { updateThreadUnreadCount } from './slice/threadSlice.jsx';

import { setDiscussionUnreadCount, setupBroadcastListener, cleanupBroadcast, setTaskDiscussionTyping, setChatIconVisible, setShowChatbox, toggleChatbox, hideChatIconOnRoute } from '../src/slice/uiSlice.jsx'
import { setUserOnline, setUserOffline, updateUserPresence } from '../src/slice/chatSlice.jsx';
import { useStore } from 'react-redux';
import EnhancedTypingIndicator from './components/EnhancedTypingIndicator.jsx';
import FocusIndicator from './components/FocusIndicator.jsx';
import './assets/EnhancedTypingIndicator.css';
import './assets/FocusIndicator.css';
import WebPushNotifications from './WebPushNotifications/WebPushNotifications.jsx';
import notificationIcon from './assets/Solitaire-logo.png';
import browserNotificationIcon from './assets/Solitaire_logo_browsernotfication.PNG';
import QuotationDollor from "./components/QuotationDollor.jsx";
import LoginForm from './loginForm.jsx'
import LiveCallMount from './SalesCommandCenter/live/LiveCallMount.jsx';
function Dashboard() {
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [refreshingIds, setRefreshingIds] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  // Get chat UI state from Redux instead of local state
  const { chatIconVisible, showChatbox } = useSelector((state) => state.ui);

  const dispatch = useDispatch();
  const store = useStore(); // Add store for BroadcastChannel
  const { token, user } = useSelector((state) => state.auth);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [open, setOpen] = useState(false);
  const [customopen, setCustomOpen] = useState(false)
  const [modalData, setModalData] = useState(null);
  const [isConnected, setIsConnected] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [showDisconnectBar, setShowDisconnectBar] = useState(false);
  const [showConnectedBar, setShowConnectedBar] = useState(false);
  const disconnectTimerRef = useRef(null);
  const disconnectWasShownRef = useRef(false);
  const [isLoading, setLoading] = useState(true)
  const [openCustomSnackbar, setOpenCustomSnackbar] = useState(false);
  const [snackbarRole, setSnackbarRole] = useState('');
  const [socket, setSocket] = useState(null);
  const chatNotifBufferRef = useRef(new Map());
  const chatNotifTimeoutsRef = useRef(new Set());
  const { groups, loading, error } = useSelector(state => state.chat);
  const [showSessionModal, setShowSessionModal] = useState(false)
  const typingIndicators = useSelector(state => state.ui.typingIndicators || {});

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 1024px)");

    const handleMediaChange = (event) => {
      setIsMobile(event.matches);
      if (event.matches) {
        setSidebarOpen(false);
      }
    };

    handleMediaChange(mediaQuery);

    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener("change", handleMediaChange);
    } else {
      mediaQuery.addListener(handleMediaChange);
    }

    return () => {
      if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener("change", handleMediaChange);
      } else {
        mediaQuery.removeListener(handleMediaChange);
      }
    };
  }, []);



  useEffect(() => {
    if (!socket) return;

    // ✅ BACKEND TRIGGERS → MODAL POPS UP!
    socket.on('session:expiring', (data) => {
      console.log('⚠️ Backend triggered warning:BackendBackendBackendBackendBackendBackendBackendBackendBackendBackendBackendBackend', data);
      setModalData(data); // 👈 THIS MAKES MODAL POPUP!
      setShowSessionModal(true)
    });

    return () => {
      socket.off('session:expiring');
    };
  }, [socket]);


  useEffect(() => {
    const newSocket = getSocket();
    // console.log("newsocktenewsockweyt",newSocket)
    if (newSocket) {
      setSocket(newSocket); // ✅ Triggers re-render + useEffect
    }
    // const [socket, setSocket] = useState(null);
  });

  useEffect(() => {
    return () => {
      chatNotifTimeoutsRef.current.forEach((timeoutId) => {
        clearTimeout(timeoutId);
      });
      chatNotifTimeoutsRef.current.clear();
    };
  }, []);

  // console.log(socket,"dashboared")
  // console.log("dashboard is mounted dashbpard is mounted")

  // useEffect(()=>{
  //   // console.log('socket is changeing soket is changesing',"value of socket",socket)

  // },[socket])

  useEffect(() => {
    console.log('🔔 Initializing browser notifications...');

    if ("Notification" in window) {
      console.log('✅ Browser supports Notification API');

      // Check current permission status
      console.log('🔍 Current permission:', Notification.permission);

      if (Notification.permission === "default") {
        console.log('📝 Requesting notification permission...');
        Notification.requestPermission().then(permission => {
          console.log('✅ Permission response:', permission);

          if (permission === "granted") {
            console.log('🎉 Notifications enabled!');
            // Test notification
            try {
              new Notification("🔔 Notifications Enabled!", {
                body: "You will now receive browser notifications",
                requireInteraction: false,
                silent: true
              });
            } catch (error) {
              console.error('❌ Test notification failed:', error);
            }
          } else if (permission === "denied") {
            console.warn('🚫 Notifications blocked by user');
          }
        }).catch(error => {
          console.error('❌ Permission request failed:', error);
        });
      } else if (Notification.permission === "granted") {
        console.log('✅ Notifications already enabled');
      } else {
        console.warn('🚫 Notifications denied');
      }
    } else {
      console.error('❌ Browser does not support notifications');
    }
  }, []);

  useEffect(() => {

    dispatch(OnGetMyGroups());

  }, [dispatch]);

  // Setup BroadcastChannel for multi-tab sync
  useEffect(() => {
    setupBroadcastListener(store);
    console.log('📡 Multi-tab sync enabled via BroadcastChannel');

    return () => {
      cleanupBroadcast();
    };
  }, [store]);
  console.log(user, "usersusersusersuses   usersusersusersuses   usersusersusersuses      usersusersusersuses    usersusersusersuses")
  useEffect(() => {
    if (!socket) return; // Exit if socket is not initialized

    const handleConnect = () => {
      setLoading(false); // Hide loading when socket connects
    };

    if (socket.connected) {
      setIsConnected(true); // Already connected
      setLoading(false);
    } else {
      socket.on("connect", handleConnect); // Wait for connect event

      const timeout = setTimeout(() => {
        setLoading(false); // Fallback in case socket doesn't connect in 3s
      }, 3000);

      return () => {
        clearTimeout(timeout);
        socket.off("connect", handleConnect); // Clean up listener on unmount
      };
    }
  }, [socket]);

  // ========= Help Ticket Notifications =========
  useEffect(() => {
    if (!socket) return;

    const handleTicketCreated = (ticket) => {
      console.log('📋 Help ticket created:', ticket);

      if (Notification.permission === 'granted') {
        new Notification(`🎫 New Help Ticket Created`, {
          body: `Subject: ${ticket.subject}\nPriority: ${ticket.priority}\nStatus: ${ticket.status}`,
          tag: ticket._id,
          requireInteraction: true,
        });
      } else {
        Notification.requestPermission().then(permission => {
          if (permission === 'granted') {
            new Notification(`🎫 New Help Ticket Created`, {
              body: `Subject: ${ticket.subject}\nPriority: ${ticket.priority}\nStatus: ${ticket.status}`,
              tag: ticket._id,
              requireInteraction: true,
            });
          }
        });
      }
    };

    const handleTicketUpdated = (ticket) => {
      console.log('🔄 Help ticket updated:', ticket);

      if (Notification.permission === 'granted') {
        new Notification(`🎫 Help Ticket Updated`, {
          body: `Subject: ${ticket.subject}\nStatus: ${ticket.status}\nPriority: ${ticket.priority}`,
          tag: ticket._id,
          requireInteraction: true,
        });
      } else {
        Notification.requestPermission().then(permission => {
          if (permission === 'granted') {
            new Notification(`🎫 Help Ticket Updated`, {
              body: `Subject: ${ticket.subject}\nStatus: ${ticket.status}\nPriority: ${ticket.priority}`,
              tag: ticket._id,
              requireInteraction: true,
            });
          }
        });
      }
    };

    const handleTicketMessage = (payload) => {
      console.log('💬 Help ticket message:', payload);

      if (Notification.permission === 'granted') {
        new Notification(`💬 New Help Ticket Reply`, {
          body: `Ticket: ${payload.subject}\nMessage: ${payload.content || 'New message received'}`,
          tag: `ticket-${payload.ticketId}`,
          requireInteraction: true,
        });
      } else {
        Notification.requestPermission().then(permission => {
          if (permission === 'granted') {
            new Notification(`💬 New Help Ticket Reply`, {
              body: `Ticket: ${payload.subject}\nMessage: ${payload.content || 'New message received'}`,
              tag: `ticket-${payload.ticketId}`,
              requireInteraction: true,
            });
          }
        });
      }
    };

    socket.on('helpTicket:created', handleTicketCreated);
    socket.on('helpTicket:updated', handleTicketUpdated);
    socket.on('helpTicket:message', handleTicketMessage);

    return () => {
      socket.off('helpTicket:created', handleTicketCreated);
      socket.off('helpTicket:updated', handleTicketUpdated);
      socket.off('helpTicket:message', handleTicketMessage);
    };
  }, [socket]);

  useEffect(() => {
    if (!socket) return;

    const handleThreadUnreadCount = (data) => {
      if (!data || data.userId !== user.id) return;

      dispatch(updateThreadUnreadCount({
        threadId: data.threadId,
        count: data.unreadCount,
        mainThreadId: data.mainThreadId
      }));
    };

    socket.on("threadmessage:unreadcount", handleThreadUnreadCount);

    return () => {
      socket.off("threadmessage:unreadcount", handleThreadUnreadCount);
    };
  }, [socket, user.id, dispatch]);

  // ===== TYPING INDICATORS =====
  useEffect(() => {
    if (!socket) return;

    const handleUserTyping = (data) => {
      console.log('👀 Dashboard: User typing event:', data);
      const { sender, senderName, isTyping } = data;

      // Update Redux state
      dispatch(setUserTyping({
        userId: sender,
        senderName,
        isTyping
      }));

      // Show browser notification and snackbar for typing
      if (isTyping) {
        const notificationTitle = `📝 ${senderName} is typing...`;
        const iconPath = notificationIcon;

        // Browser notification with custom icon
        if (Notification.permission === 'granted') {
          try {
            new Notification(notificationTitle, {
              body: 'Someone is typing a message to you',
              icon: iconPath,
              tag: `chat-typing-${sender}`,
              requireInteraction: false,
              silent: true // Don't play sound for typing notifications
            });
          } catch (error) {
            console.warn('Browser notification failed:', error);
            // Fallback without icon
            new Notification(notificationTitle, {
              body: 'Someone is typing a message to you',
              tag: `chat-typing-${sender}`,
              requireInteraction: false,
              silent: true
            });
          }
        } else if (Notification.permission !== "denied") {
          Notification.requestPermission().then(permission => {
            if (permission === 'granted') {
              try {
                new Notification(notificationTitle, {
                  body: 'Someone is typing a message to you',
                  icon: iconPath,
                  tag: `chat-typing-${sender}`,
                  requireInteraction: false,
                  silent: true
                });
              } catch (error) {
                new Notification(notificationTitle, {
                  body: 'Someone is typing a message to you',
                  tag: `chat-typing-${sender}`,
                  requireInteraction: false,
                  silent: true
                });
              }
            }
          });
        }

        setSnackbarMessage(`📝 ${senderName} is typing...`);
        setOpen(true);

        // Auto-hide after 3 seconds
        setTimeout(() => {
          setOpen(false);
        }, 3000);
      }
    };

    socket.on('userTyping', handleUserTyping);
    return () => {
      socket.off('userTyping', handleUserTyping);
    };
  }, [socket]);

  // ===== ENHANCED TASK DISCUSSION TYPING INDICATORS =====
  useEffect(() => {

    if (!socket) return;

    const handleTaskDiscussionTyping = (data) => {
      // console.log('👀 Dashboard: Enhanced task discussion typing event:', data);
      const { sender, senderName, taskId, discussionId, isTyping } = data;

      // Update Redux state for cross-tab sync
      dispatch(setTaskDiscussionTyping({
        taskId,
        userId: sender,
        senderName,
        isTyping
      }));

      if (isTyping) {
        // Enhanced clickable notification
        const notificationTitle = `📝 ${senderName} is typing in Task #${taskId}`;
        const notificationBody = `Click to open task discussion`;
        const iconPath = browserNotificationIcon;

        // Clickable browser notification
        if (Notification.permission === 'granted') {
          try {
            const notification = new Notification(notificationTitle, {
              body: notificationBody,
              icon: iconPath,
              tag: `task-typing-${taskId}-${sender}`,
              requireInteraction: false,
              silent: true,
              data: { taskId, discussionId, type: 'task-typing' } // Data for click handling
            });

            // Handle notification click
            notification.onclick = () => {
              window.focus();
              // Navigate to task discussion
              navigate(`/maintask?taskId=${taskId}&discussion=${discussionId}`);
              notification.close();
            };

          } catch (error) {
            console.warn('Enhanced notification failed:', error);
          }
        }

        // Enhanced snackbar with navigation
        // setSnackbarMessage(
        //   <EnhancedTypingIndicator 
        //     who={senderName}
        //     taskId={taskId}
        //     discussionId={discussionId}
        //     type="task"
        //   />
        // );
        setOpen(true);

        // Auto-hide after 5 seconds (longer for clickable)
        setTimeout(() => {
          setOpen(false);
        }, 5000);
      }
    };

    socket.on('taskDiscussionTypingDashboard', handleTaskDiscussionTyping);
    return () => {
      socket.off('taskDiscussionTypingDashboard', handleTaskDiscussionTyping);
    };
  }, [socket, dispatch, navigate]);

  // ===== THREAD TYPING INDICATORS =====
  useEffect(() => {
    // console.log("Thread Typing Handler Initialized");
    if (!socket) return;

    const handleThreadTyping = (data) => {
      // console.log('🧵 Dashboard: Thread typing event:', data);
      const { threadId, userId, senderName, isTyping } = data;

      if (isTyping) {
        // Enhanced clickable notification for thread typing
        const notificationTitle = `🧵 ${senderName} is typing in thread`;
        const notificationBody = `Click to open thread discussion`;
        const iconPath = browserNotificationIcon;

        // Clickable browser notification
        if (Notification.permission === 'granted') {
          try {
            const notification = new Notification(notificationTitle, {
              body: notificationBody,
              icon: iconPath,
              tag: `thread-typing-${threadId}-${userId}`,
              requireInteraction: false,
              silent: true,
              data: { threadId, type: 'thread-typing' }
            });

            // Handle notification click - open thread in modal
            notification.onclick = () => {
              window.focus();
              // You can emit an event to open thread modal or navigate
              // navigate(`/chat/thread/${threadId}`);
              notification.close();
            };

          } catch (error) {
            console.warn('Thread typing notification failed:', error);
          }
        }
        setSnackbarMessage(`💼 ${senderName}: ${newMessage.content}`);
        // Enhanced snackbar with thread info
        setSnackbarMessage(
          <EnhancedTypingIndicator
            who={senderName}
            threadId={threadId}
            type="thread"
          />
        );
        setOpen(true);

        // Auto-hide after 4 seconds
        setTimeout(() => {
          setOpen(false);
        }, 4000);
      }
    };

    const handleThreadTypingStop = (data) => {
      // console.log('🧵 Dashboard: Thread typing stopped:', data);
      // Optional: Handle typing stop if needed
    };

    socket.on('threadTyping', handleThreadTyping);
    socket.on('threadTypingStop', handleThreadTypingStop);

    return () => {
      socket.off('threadTyping', handleThreadTyping);
      socket.off('threadTypingStop', handleThreadTypingStop);
    };
  }, [socket, dispatch, navigate]);

  useEffect(() => {
    // console.log('📱 CHAT USEEFFECT RUNNING!');
    // console.log('🔧 Setting up receiveMessagefordashborad listener');
    // console.log('🔌 Socket details:', {
    //   exists: !!socket,
    //   connected: socket?.connected,
    //   id: socket?.id,
    //   type: typeof socket
    // });

    if (!socket) {
      console.log('❌ CHAT: No socket available for receiveMessagefordashborad - EXITING');
      return;
    }

    console.log('✅ CHAT: Socket exists, proceeding with listener setup');

    const handleDashboardMessage = (newMessage) => {
      console.log('🎯 DASHBOARD MESSAGE RECEIVED:', newMessage);
      console.log('📨 Message details:', {
        _id: newMessage._id,
        content: newMessage.content,
        sender_user: newMessage.sender_user,
        role: newMessage.role,
        isfile: newMessage.isfile
      });

      const senderName = newMessage.sender_user?.userName || newMessage.sender_user?.firstName || 'Unknown User';
      console.log('👤 Sender name extracted:', senderName);

      const senderId = "all";
      const senderTag = "chat-message";
      const messageText = newMessage.isfile
        ? `${senderName} sent you a file`
        : `${senderName}: ${newMessage.content || ""}`.trim();

      const clearSenderBuffer = () => {
        chatNotifBufferRef.current.delete(senderId);
      };

      const updateNotificationBuffer = () => {
        const entry =
          chatNotifBufferRef.current.get(senderId) || { messages: [], total: 0 };
        const safeMessage = messageText || `${senderName}: (no content)`;
        entry.total += 1;
        entry.messages = [...entry.messages, safeMessage].slice(-5);
        entry.lastNotificationId = (entry.lastNotificationId || 0) + 1;
        chatNotifBufferRef.current.set(senderId, entry);

        const remaining = entry.total - entry.messages.length;
        const bodyLines = entry.messages.join('\n');
        const body =
          remaining > 0 ? `${bodyLines}\n+${remaining} more` : bodyLines;
        return { body, notificationId: entry.lastNotificationId };
      };

      const showNotification = (title) => {
        const { body, notificationId } = updateNotificationBuffer();
        console.log('dY"" Attempting to show notification:', title, body);
        // console.log('dY"' Current permission:', Notification.permission);

        if (Notification.permission === "granted") {
          try {
            console.log('?o. Creating notification...');
            const notification = new Notification(title, {
              body: body,
              tag: senderTag,
              renotify: true,
              requireInteraction: true
            });
            notification.onclick = () => {
              clearSenderBuffer();
              notification.close();
            };
            notification.onclose = () => {
              const latest = chatNotifBufferRef.current.get(senderId);
              if (latest?.lastNotificationId === notificationId) {
                clearSenderBuffer();
              }
            };
            const timeoutId = setTimeout(() => {
              const latest = chatNotifBufferRef.current.get(senderId);
              if (latest?.lastNotificationId === notificationId) {
                clearSenderBuffer();
              }
              chatNotifTimeoutsRef.current.delete(timeoutId);
            }, 9000);
            chatNotifTimeoutsRef.current.add(timeoutId);
            console.log('?o. Notification created successfully');
          } catch (error) {
            console.error('??O Notification creation failed:', error);
          }
        } else if (Notification.permission === "default") {
          console.log('dY"? Requesting notification permission...');
          Notification.requestPermission().then(permission => {
            console.log('dY"" Permission granted:', permission);
            if (permission === "granted") {
              try {
                const notification = new Notification(title, {
                  body: body,
                  tag: senderTag,
                  renotify: true,
                  requireInteraction: true
                });
                notification.onclick = () => {
                  clearSenderBuffer();
                  notification.close();
                };
                notification.onclose = () => {
                  const latest = chatNotifBufferRef.current.get(senderId);
                  if (latest?.lastNotificationId === notificationId) {
                    clearSenderBuffer();
                  }
                };
                const timeoutId = setTimeout(() => {
                  const latest = chatNotifBufferRef.current.get(senderId);
                  if (latest?.lastNotificationId === notificationId) {
                    clearSenderBuffer();
                  }
                  chatNotifTimeoutsRef.current.delete(timeoutId);
                }, 4000);
                chatNotifTimeoutsRef.current.add(timeoutId);
                console.log('?o. Notification shown after permission grant');
              } catch (error) {
                console.error('??O Notification failed after permission:', error);
              }
            }
          });
        } else {
          console.warn('dYs? Notifications are denied or blocked');
        }
      };

      if (newMessage.role === "SUPERADMIN" || newMessage.role?.toLowerCase() === "admin") {
        console.log('💼 Processing Super Admin message');
        showNotification("💼 Super Admin Message");
        setSnackbarMessage(`💼 ${senderName}: ${newMessage.content}`);
        setCustomOpen(true);
        setSnackbarRole(newMessage.role);
        setOpenCustomSnackbar(true);
        setOpen(true);
      } else {
        if (newMessage.isfile) {
          console.log('📎 Processing file message');
          showNotification("📎 New File");
          setSnackbarMessage(`📎 ${senderName} sent you a file`);
        } else {
          console.log('💬 Processing regular message');
          showNotification("💬 New Message");
          setSnackbarMessage(`${senderName}: ${newMessage.content}`);
        }
        setOpen(true);
      }
    };

    socket.on("receiveMessagefordashborad", handleDashboardMessage);
    console.log('✅ receiveMessagefordashborad listener attached');

    return () => {
      console.log('🧹 Removing receiveMessagefordashborad listener');
      socket.off("receiveMessagefordashborad", handleDashboardMessage);
    };
  }, [socket]);

  useEffect(() => {
    console.log("socket from")
    if (!socket) return;

    const handleUnreadCountUpdate = (data) => {
      // console.log('handleUnreadCountUpdate      handleUnreadCountUpdate      handleUnreadCountUpdate      ')
      // console.log('handleUnreadCountUpdate      handleUnreadCountUpdate      handleUnreadCountUpdate      ')
      // Only update if the update is for this user
      console.log(data, user.id);
      console.log(typeof data.unreadCount)
      console.log(data.receiver === user.id)
      if (data.receiver === user.id && typeof data.unreadCount === "number") {
        // console.log("conddtion true true true")
        dispatch(
          setReadCount({
            value: data.unreadCount,
            sender: data.sender,
            receiver: data.receiver,
          })
        );

      }
    };

    socket.on("unreadCountUpdatedashboard", handleUnreadCountUpdate);

    // Cleanup on unmount or socket change
    return () => {
      socket.off("unreadCountUpdatedashboard", handleUnreadCountUpdate);
    };
  }, [socket, user.id, dispatch]);

  useEffect(() => {
    if (!socket) return;

    const handleNotification = (payload) => {

      if (Notification.permission === "granted") {
        new Notification(`📌you have recived message in task discussion ${payload.content || "Task"} `, {
          body: `${payload.id || ""}\n${payload.taskText || ""}`,
          tag: payload.id,
          requireInteraction: true,
          renotify: true
        });
      }
    };

    socket.on("receiveTaskComment:dashboard", handleNotification);

    return () => {
      socket.off("receiveTaskComment:dashboard", handleNotification);
    };
  }, [socket]);

  useEffect(() => {
    if (!socket) return;

    const handleThreadNotification = (threadMessage) => {
      // console.log("🧵 Thread notification received:", threadMessage);

      // Handle different data structures that might be sent
      let senderName, messageContent, threadId;

      try {
        // Extract sender name from various possible structures
        if (threadMessage.senderName) {
          // Use direct senderName if available (new backend structure)
          senderName = threadMessage.senderName;
          console.log('✅ Using direct senderName:', senderName);
        } else if (threadMessage.senderInfo) {
          // Extract from senderInfo object (new backend structure)
          senderName = threadMessage.senderInfo.firstName ||
            threadMessage.senderInfo.lastName ||
            threadMessage.senderInfo.userName ||
            'Someone';
          // console.log('✅ Extracted from senderInfo:', senderName);
        } else if (threadMessage.sender && typeof threadMessage.sender === 'object') {
          // Extract from sender object (old structure)
          senderName = threadMessage.sender.firstName ||
            threadMessage.sender.lastName ||
            threadMessage.sender.userName ||
            threadMessage.sender.name ||
            'Someone';
          console.log('✅ Extracted from sender object:', senderName);
        } else {
          // Fallback
          senderName = 'Someone';
          console.log('⚠️ Using fallback sender name');
        }

        // Extract message content
        messageContent = threadMessage.content || threadMessage.message || "New thread message";

        // Extract thread ID
        threadId = threadMessage.conversation || threadMessage.threadId || threadMessage._id;

        console.log('🔍 Extracted data:', { senderName, messageContent, threadId });
      } catch (error) {
        console.error('❌ Error extracting thread notification data:', error);
        senderName = 'Someone';
        messageContent = 'New thread message';
        threadId = null;
      }

      // Create proper notification title and body
      const notificationTitle = `🧵 New Thread Message`;
      const notificationBody = `${senderName}: ${messageContent}`;

      console.log('🔔 Final notification:', { senderName, messageContent, body: notificationBody });

      const showNotification = () => {
        new Notification(notificationTitle, {
          body: notificationBody,
          tag: `thread-message-${threadMessage._id}`,
          requireInteraction: true,
          icon: browserNotificationIcon,
          renotify: true
        });
      };

      if (Notification.permission === "granted") {
        showNotification();
      } else if (Notification.permission === "default") {
        Notification.requestPermission().then((permission) => {
          if (permission === "granted") {
            showNotification();
          }
        });
      }
      setSnackbarMessage(`${senderName}: ${messageContent}`);

      setOpen(true);
    };

    socket.on("notification:threadnotification", handleThreadNotification);

    return () => {
      socket.off("notification:threadnotification", handleThreadNotification);
    };
  }, [socket]);

  useEffect(() => {
    if (!socket) return;

    const handleNotification = (payload) => {
      console.log("payload paylaod  paylaod")
      if (Notification.permission === "granted") {
        new Notification(`📌 ${payload.taskId} Updated`, {
          body: `${payload.message}\n${payload.taskText}`,
          tag: payload.taskId,
          requireInteraction: true,
        });

      } else {
        Notification.requestPermission().then((permission) => {
          if (permission === "granted") {
            new Notification(`📌 ${payload.taskId} Updated`, {
              body: `${payload.message}\n${payload.taskText}`,
              tag: payload.taskId,
              requireInteraction: true,
            });

          }
        });
      }
    };

    socket.on("notification:taskUpdated", handleNotification);

    return () => {
      socket.off("notification:taskUpdated", handleNotification);
    };
  }, [socket]);


  useEffect(() => {
    if (!socket) return;

    const handleNotification = (payload) => {
      // console.log("📩 Group message notification received:", payload);

      const { groupname, senderName, content, isFile, fileUrl, fileType, userinformation } = payload;
      const senderFirstName = payload.userinformation?.firstName || "Unknown"
      // Notification title
      const title = `📌 From  channel ${groupname} — You have received a new message from ${senderFirstName}`;

      // Notification body
      let body = content || "";
      if (isFile && fileUrl) {
        body += `\n📎 File: ${fileType || "Attachment"}`;
      }

      const showNotification = () => {
        new Notification(title, {
          body: body.trim(),
          requireInteraction: true
        });
      };

      // Check permission
      if (Notification.permission === "granted") {
        showNotification();
      } else {
        Notification.requestPermission().then((permission) => {
          if (permission === "granted") {
            showNotification();
          }
        });
      }
    };

    socket.on("receiveGroupMessageNotification", handleNotification);

    return () => {
      socket.off("receiveGroupMessageNotification", handleNotification);
    };
  }, [socket]);




  useEffect(() => {
    if (!socket) return;
    socket.emit("getunreadgroupmessageCount", {
      groups,
      user

    })


  }, [groups])






  useEffect(() => {
    if (!socket) return;

    socket.on("getRealTimeTaskConverstionCount", (data) => {
      const { discussionId, count, lastMessage } = data;

      // 👇 Ignore if current user is the sender
      if (lastMessage?.sender?._id === user.id) {
        return;
      }

      dispatch(
        setDiscussionUnreadCount({
          discussionId,
          count,
          lastMessage,
        })
      );
    });

    return () => {
      socket.off("getRealTimeTaskConverstionCount");
    };
  }, [socket, user.id, dispatch]);


  useEffect(() => {
    console.log(socket)
    if (!socket) return;

    const sendeventtogetcount = (data) => {
      // console.log("📩 Dashboard unread group message counts:",   groups,
      //   user);
      const information = { groups, user };
      socket.emit('getunreadgroupmessageCount', information)
      // if (Array.isArray(data)) {
      //   const mapped = data.reduce((acc, item) => {
      //     acc[item._id] = item.count;
      //     return acc;
      //   }, {});
      //   // dispatch(updateUnreadCounts(mapped)); // ✅ update Redux
      // }
    };

    // Attach listener
    socket.on("unreadGroupMessageCountDashboard", sendeventtogetcount);


    return () => {
      socket.off("unreadGroupMessageCountDashboard", sendeventtogetcount);
    };
  }, [socket, dispatch, groups]);

  // User Presence Status Listener
  useEffect(() => {
    if (!socket) return;

    const handleStatusUpdate = (data) => {
      // console.log('📡 Received status update:', data);
      const { userId, isOnline, userName, lastSeen } = data;

      if (isOnline) {
        dispatch(setUserOnline({
          userId,
          userName,
          timestamp: lastSeen || new Date().toISOString()
        }));
      } else {
        dispatch(setUserOffline({
          userId,
          timestamp: lastSeen || new Date().toISOString()
        }));
      }
    };

    const handleBulkPresenceUpdate = (presenceArray) => {
      // console.log('📡 Received bulk presence update:', presenceArray);
      presenceArray.forEach(user => {
        dispatch(updateUserPresence({
          userId: user.userId,
          isOnline: user.isOnline,
          userName: user.userName,
          lastSeen: user.lastSeen
        }));
      });
    };

    socket.on('statusUpdate', handleStatusUpdate);
    socket.on('bulkPresenceUpdate', handleBulkPresenceUpdate);

    return () => {
      socket.off('statusUpdate', handleStatusUpdate);
      socket.off('bulkPresenceUpdate', handleBulkPresenceUpdate);
    };
  }, [socket, dispatch]);




  const handleLogout = () => {
    dispatch(logout());
    navigate("/signin");
  };

  useEffect(() => {
    if (!socket) return;
    const sendeventtogetcount = (data) => {
      // console.log("📩 Dashboard unread group message counts:",   groups,
      //   user);
      const information = { groups, user };
      socket.emit('getunreadgroupmessageCount', information)
      // if (Array.isArray(data)) {
      //   const mapped = data.reduce((acc, item) => {
      //     acc[item._id] = item.count;
      //     return acc;
      //   }, {});
      //   // dispatch(updateUnreadCounts(mapped)); // ✅ update Redux
      // }
    };

    // Attach listener
    socket.on("unreadGroupMessageCountDashboard", sendeventtogetcount);


    return () => {
      socket.off("unreadGroupMessageCountDashboard", sendeventtogetcount);
    };
  }, [socket, dispatch, groups]);



  useEffect(() => {
    const path = location.pathname;
    console.log(path, "------------path");

    // Use Redux action to handle chat icon visibility based on route
    dispatch(hideChatIconOnRoute({ route: path }));
  }, [location.pathname, dispatch]);

  // // Run when path changes
  // console.log("ChatIconVisible", ChatIconVisible)



  // ✅ Capture the current location
  // console.log("Current Route---------------------:", location.pathname);
  const toggleSidebar = () => {
    console.log(isSidebarOpen, "from toogel bar")
    setSidebarOpen(!isSidebarOpen);
  };

  const handleTaskClick = (task) => {
    if (task.route) {
      navigate(task.route);
    }
  };

  const handleRefreshClick = (id) => {
    setRefreshingIds((prev) => [...prev, id]);
    setTimeout(() => {
      setRefreshingIds((prev) => prev.filter((refreshId) => refreshId !== id));
    }, 1000);
  };

  const isEntryPoint = location.pathname === "/" || location.pathname === "/entrypoint";
  const handleExtend = () => {



  }



  const handleLoginform = () => {



  }

  useEffect(() => {


    if (!socket) {
      console.warn("No socket found");
      setIsConnected(false);
      return;
    }

    const handleConnect = () => {
      setIsConnected(true);
      setIsFirstLoad(false);
      if (disconnectTimerRef.current) {
        clearTimeout(disconnectTimerRef.current);
        disconnectTimerRef.current = null;
      }
      setShowDisconnectBar(false);
      if (disconnectWasShownRef.current) {
        disconnectWasShownRef.current = false;
        setShowConnectedBar(true);
        setTimeout(() => setShowConnectedBar(false), 2000);
      }
    };

    const handleOnline = () => {
      if (socket && !socket.connected) socket.connect();
    };

    const handleOffline = () => {
      disconnectWasShownRef.current = true;
      setShowDisconnectBar(true);
      setShowConnectedBar(false);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    const handleDisconnect = () => {
      setIsConnected(false);
      disconnectTimerRef.current = setTimeout(() => {
        if (!socket.connected) {
          disconnectWasShownRef.current = true;
          setShowDisconnectBar(true);
        }
      }, 3000);
    };

    socket.on("connect", handleConnect);
    socket.on("disconnect", handleDisconnect);

    // Set initial state
    setIsConnected(socket.connected);
    if (socket.connected) setIsFirstLoad(false);

    const handleVisibility = () => {
      if (document.visibilityState === 'visible' && !socket.connected) {
        socket.connect();
      }
    };
    document.addEventListener('visibilitychange', handleVisibility);

    return () => {
      socket.off("connect", handleConnect);
      socket.off("disconnect", handleDisconnect);
      document.removeEventListener('visibilitychange', handleVisibility);
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [socket?.connected]);
  if (isFirstLoad && !isConnected) return <Loader text="Dashboard is loading ..." />;

  return (
      <>
        {/* Focus Indicator - Shows which tab is active */}
        {/* <FocusIndicator /> */}

        <Navbar toggleSidebar={toggleSidebar} onLogout={handleLogout} />

        <Snackbar open={showDisconnectBar} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} sx={{ top: '64px !important' }}>
          <div style={{
            background: '#1E293B',
            color: '#fff',
            padding: '10px 24px',
            borderRadius: '8px',
            fontSize: '13px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.2)'
          }}>
            🔴 No internet. Reconnecting...
          </div>
        </Snackbar>

        <Snackbar open={showConnectedBar} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} sx={{ top: '64px !important' }}>
          <div style={{
            background: '#16A34A',
            color: '#fff',
            padding: '10px 24px',
            borderRadius: '8px',
            fontSize: '13px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.2)'
          }}>
            🟢 Connected!
          </div>
        </Snackbar>

        <div className="dashboard-layout">
          <div className="app-container">
            {!isEntryPoint && (
              <>
                {isMobile && isSidebarOpen && (
                  <div
                    className="sidebar-backdrop"
                    onClick={() => setSidebarOpen(false)}
                  />
                )}
                {/* Sidebar */}
                <div className={`sidebar-container ${isSidebarOpen ? "open" : "closed"}`}>
                  <Sidebar open={isSidebarOpen} />
                </div>
              </>
            )}

            <Snackbar
              anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
              open={open}
              onClose={() => setOpen(false)}
              autoHideDuration={10000}
              message={snackbarMessage}
            />

            {open && openCustomSnackbar && (
              <div
                style={{
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  width: '100vw',
                  height: '100vh',
                  backgroundColor: 'rgba(0, 0, 0, 0.5)',
                  zIndex: 1300,
                  pointerEvents: 'auto',  // ensures overlay blocks clicks
                }}
              />
            )}

            <CustomSnackbar

              customopen={openCustomSnackbar}
              setOpenCustomSnackbar={setOpenCustomSnackbar}
              snackbarMessage={snackbarMessage}
              role={snackbarRole}
              style={{ zIndex: 1301 }}  // snackbar above overlay
            />



            {/* User Presence Component - No UI, just handles online/offline */}
            <UserPresence />
            <WebPushNotifications />
            {/* Main Content & Outlet */}
            <>
              {modalData && (
                <LoginForm
                  open={showSessionModal}  // 👈 ALWAYS true when modalData exists
                  expiresAt={modalData.expiresAt}
                  extendOptions={modalData.extendOptions}
                  onExtend={handleExtend}

                  onClose={() => setShowSessionModal(false)}

                />
              )}
            </>   
          

            {!isEntryPoint && ["EA", "SUPER_ADMIN", "ADMIN"].includes(user.role) && (
              <QuotationDollor />
            )}
            <div className={`content-container ${!isEntryPoint && isSidebarOpen ? "with-sidebar" : "full-width"}`}>
              {showChatbox && <ChatAppSmall SetChatBox={(show) => dispatch(setShowChatbox(show))} />}
              {chatIconVisible && <ChatIcon SetChatBox={() => dispatch(toggleChatbox())} />}
              {/* Wraps the Outlet so a live call survives moving between modules, and
                  so the Sales Command Center pages read the same call the dock shows. */}
              <LiveCallMount>
                <Outlet />
              </LiveCallMount>
            </div>
          </div>
        </div>
      </>
  );


}




export default Dashboard;
